module.exports = __webpack_public_path__ + "img/Flag_of_Albania.9ca1e7c5.svg";